import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'gift_pack_card_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      rules: {
        card_type: [{
          required: true,
          message: '请先选择一种样式',
          trigger: 'change'
        }],
        exchange_content: [{
          required: true,
          message: '请输入按钮文案',
          trigger: 'change'
        }, {
          max: 4,
          message: '文案长度最多4个字',
          trigger: 'change'
        }],
        is_show_expiration_date: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }]
        // display_unlimited_card: [
        // 	{ required: true, message: '选项不可为空', trigger: 'change' }
        // ]
      },
      defaultList: []
    };
  },
  methods: {
    changeCardType: function changeCardType(item) {
      if (item.card_type === this.value.config.card_type) {
        return;
      }
      this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
        card_type: item.card_type,
        imageurl: item.imageurl_c
      }));
    }
  },
  created: function created() {
    var _this$tabListFlat$fin,
      _this = this;
    var _ref = ((_this$tabListFlat$fin = this.tabListFlat.find(function (i) {
        return i.key === _this.value.key;
      })) === null || _this$tabListFlat$fin === void 0 ? void 0 : _this$tabListFlat$fin.config_default_value) || {},
      _ref$card_list = _ref.card_list,
      card_list = _ref$card_list === void 0 ? [] : _ref$card_list,
      _ref$exchange_content = _ref.exchange_content,
      exchange_content = _ref$exchange_content === void 0 ? '立即兑换' : _ref$exchange_content;
    this.defaultList = card_list; // 赋值可选择的魔方导航列表

    var _this$value$config = this.value.config,
      _this$value$config$ca = _this$value$config.card_type,
      card_type = _this$value$config$ca === void 0 ? '1' : _this$value$config$ca,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$is = _this$value$config.is_show_expiration_date,
      is_show_expiration_date = _this$value$config$is === void 0 ? '1' : _this$value$config$is;
    // // 每次为图片重新赋值 因为是固定的 & 防止更换新图片
    var currentCard = this.defaultList.find(function (i) {
      return i.card_type === card_type;
    }) || {};
    this.$set(this.value, 'config', _objectSpread({
      // 新添加组件初始数据 start
      card_type: card_type,
      exchange_content: exchange_content,
      is_show_expiration_date: is_show_expiration_date,
      imageurl: currentCard.imageurl_c,
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index
    }, this.value.config));
  }
};